/**
 * Where the certificate will be, before it exists. The store issues it in the
 * same transaction that finishes the document, so it waits for the same rule
 * as RETENTION_STARTS (keepFor.ts). "Once every party has signed" was met while a viewer
 * had still to open the document, and read literally it named viewers and
 * copy recipients, who never sign (review 4, docs-5).
 */
export const CERTIFICATE_LATER = 'The certificate is available once the document is finished.'
